import { executeRequest, Request, Response } from '@jfs/network'
import { getAPIURL, getPaymentHeader } from '../config'

const responseParser = (response: Response) => {
  const { data } = response
  return data
}
/**
 * New PG
 * @param merchantID
 */
export const offerValidate = (input: any) => {
  const request: Request<{}> = {
    apiPath: `${getAPIURL('offerValidate')}`,
    method: 'POST',
    headers: getPaymentHeader(),
    body: input,
  }
  return executeRequest(request)
    .then((response: any) => {
      return responseParser(response)
    })
    .catch((err) => {
      const {
        data: { error },
      } = err
      throw error
    })
}
